import { useMemo } from 'react';
import { Grid, GridItem } from 'unsubscribe-ui/components/core/layout/Grid';
import Spacer from 'unsubscribe-ui/components/core/layout/Spacer';
import LanguageSelect from 'unsubscribe-ui/components/common/LanguageSelect';
import { CompanyName } from 'unsubscribe-ui/components/common/Company';
import { isMobileView } from 'unsubscribe-ui/utils/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GridPanel = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(Grid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 1,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3
      }
    }), /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 10,
        sm: 10,
        md: 8,
        lg: 6,
        xl: 6
      },
      children: children
    }), /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 1,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3
      }
    })]
  });
};
export const ContentPanel = ({
  children,
  languages,
  company
}) => {
  const isMobile = useMemo(() => isMobileView(), []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Spacer, {
      marginBlock: isMobile ? '300' : '700'
    }), /*#__PURE__*/_jsxs(GridPanel, {
      children: [/*#__PURE__*/_jsx(LanguageSelect, {
        availableLanguageCodes: languages
      }), /*#__PURE__*/_jsx(Spacer, {
        marginBlock: "300"
      }), /*#__PURE__*/_jsx(CompanyName, {
        company: company
      }), /*#__PURE__*/_jsx(Spacer, {
        marginBlock: "300"
      }), children]
    })]
  });
};